export const WORKBENCH_PATH = '/go/workbench';
